import consumer from './consumer';

document.addEventListener('DOMContentLoaded', () => {
  const subscriptionIntentionElement = document.getElementById('subscription-intention-id');

  if (!subscriptionIntentionElement) {
    return;
  }

  consumer.subscriptions.create(
    {
      channel: 'SubscriptionIntentionChannel',
      subscription_intention_id: subscriptionIntentionElement.dataset.id,
    },
    {
      received(data) {
        try {
          if (data.status === 'success') {
            setTimeout(() => {
              window.location.href = data.next_step_path;
            }, 5000);
          } else if (data.status === 'failure') {
            setTimeout(() => {
              document.getElementById('subscriptionStep1')?.classList.add('d-none');
              document.getElementById('subscriptionStep1Failure')?.classList.remove('d-none');
            }, 5000);
          } else {
            setTimeout(() => {
              document.getElementById('subscriptionStep1')?.classList.add('d-none');
              document.getElementById('subscriptionStep1Error')?.classList.remove('d-none');
            }, 5000);
          }
        } catch {
          setTimeout(() => {
            document.getElementById('subscriptionStep1')?.classList.add('d-none');
            document.getElementById('subscriptionStep1Error')?.classList.remove('d-none');
          }, 5000);
        }
      },
      rejected() {
        setTimeout(() => {
          document.getElementById('subscriptionStep1')?.classList.add('d-none');
          document.getElementById('subscriptionStep1Error')?.classList.remove('d-none');
        }, 5000);
        this.uninstall();
      },
    },
  );
});
